import { CloseIcon } from 'components/Icons'
import { ReactElement } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

const Content = styled.div<{
  top?: boolean
  bottom?: boolean
  left?: boolean
  right?: boolean
  center?: boolean
  overflow?: boolean
  position?: {
    x: number
    y: number
  }
}>`
  position: absolute;
  ${({ top }): string => (top ? 'top: 18px;' : '')}
  ${({ bottom }): string => (bottom ? 'bottom: 10px;' : '')}
  ${({ left }): string => (left ? 'left: 18px;' : '')}
  ${({ right }): string => (right ? 'right: 21px;' : '')}
  ${({ center }): string => (center ? 'left: 50%; transform: translate(-50%, 0);' : '')}
  ${({ position }): string => (position ? `left: ${position.x}px; top: ${position.y}px;` : '')}
  max-height: calc(100% - 36px);
  overflow-y: ${({ overflow }): string => (overflow ? 'auto' : 'none')};
  display: flex;
  align-items: ${({ top }): string => (top ? 'flex-start' : 'flex-end')};
  gap: 16px;
`

const ToolbarItem = styled.div`
  min-width: 31px;
  min-height: 31px;
  display: grid;
  grid-template-columns: 1fr;
`

const ToolbarButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  :hover {
    background-color: #eaeaff70;
  }

  :focus {
    background-color: #eaeaff;
  }
`

const Toolbar = styled.div<{ hasSingleItem?: boolean }>`
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: ${({ hasSingleItem }): string => (hasSingleItem ? 'column' : 'row')};
  align-items: ${({ hasSingleItem }): string => (hasSingleItem ? 'flex-start' : 'center')};
  gap: ${({ hasSingleItem }): string => (hasSingleItem ? '16px' : '24px')};
  background-color: #fff;
  box-shadow: 0px 0px 30px 0px rgba(102, 119, 150, 0.15);
  border-radius: 8px;

  ${ToolbarItem} {
    ${({ hasSingleItem }): string => (hasSingleItem ? 'width: 100%;' : '')}
  }

  ${ToolbarButton} {
    ${({ hasSingleItem }): string => (hasSingleItem ? 'justify-content: space-between;' : '')}
  }
`

const ToolbarButtonAngleIcon = styled.div<{ isCollapsed: boolean }>`
  transform: ${({ isCollapsed }): string => (isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
  margin-right: 4px;

  svg {
    fill: #28265d;
  }
`

const Panel = styled.div`
  position: relative;
  width: 338px;
  padding: 16px;
  background-color: #fff;
  border-radius: 16px;
`

const ClosePanelButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s;

    :hover {
      background-color: #eaeaff70;
    }

    :focus {
      background-color: #eaeaff;
    }
  }
`

interface IClosePanelButtonProps {
  onClick: () => void
}

const ClosePanelButton = ({ onClick }: IClosePanelButtonProps): ReactElement => {
  return (
    <ClosePanelButtonContainer>
      <button onClick={onClick}>
        <CloseIcon />
      </button>
    </ClosePanelButtonContainer>
  )
}

export default {
  Container,
  Content,
  Toolbar,
  ToolbarItem,
  ToolbarButton,
  ToolbarButtonAngleIcon,
  Panel,
  ClosePanelButton
}
